"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const fp_1 = require("lodash/fp");
const useCurry_1 = __importDefault(require("../useCurry"));
exports.default = (defaultValue = false) => {
    const [value, setValue] = (0, react_1.useReducer)((currentValue, forceValue) => ((0, fp_1.isUndefined)(forceValue)
        ? !currentValue
        : forceValue), defaultValue);
    const setOn = (0, useCurry_1.default)(setValue, true);
    const setOff = (0, useCurry_1.default)(setValue, false);
    return (0, react_1.useMemo)(() => [
        value,
        setValue,
        {
            setOn,
            setOff,
        },
    ], [setOff, setOn, value]);
};
